import React from 'react';
import { TargetIcon, ShieldCheckIcon, RocketIcon, ArrowRightIcon } from 'lucide-react';
export function HomeEnginePreview() {
  const systems = [{
    icon: TargetIcon,
    title: 'The Recruiting Engine',
    subtitle: 'Sourcing',
    description: "We don't rely on luck. We use a purpose-built system to source, screen, and qualify candidates from the cold market. We filter out the noise so you only talk to high-intent applicants who are ready to interview.",
    link: '/how-it-works#recruiting'
  }, {
    icon: ShieldCheckIcon,
    title: 'The Retention Engine',
    subtitle: 'Anchoring',
    description: 'Retention doesn\'t start at 90 days; it starts at the handshake. We don\'t just give you a manual; we actively partner with you to drive the "Commitment Conversation" and onboarding process. We help you build the accountability loops that bridge the gap between the job offer and Day 1, ensuring your new hires actually show up.',
    link: '/how-it-works#retention'
  }, {
    icon: RocketIcon,
    title: 'The Results Engine',
    subtitle: 'Production',
    description: 'This is our secret weapon. We put your rookies through our Live Sales School – immersive, structured training sessions delivered weekly. We handle the heavy lifting of initial training and buy-in so they hit the field ready to produce. We also provide active consulting to help you optimize their launch based on real performance data.',
    link: '/how-it-works#results',
    highlight: true
  }];
  return <section className="section-padding bg-white" data-id="element-409">
      <div className="container-custom" data-id="element-410">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" data-id="element-411">
          <h2 className="mb-4 md:mb-6 text-navy" data-id="element-412">
            Three Systems. One Complete Framework.
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-413">
            We handle the finding, the filtering, and the foundational training.
            You lead and develop from there.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 max-w-6xl mx-auto mb-8 md:mb-12" data-id="element-414">
          {systems.map((system, index) => {
          const Icon = system.icon;
          return <div key={index} className={`bg-white rounded p-5 md:p-6 lg:p-8 border-2 transition-all group shadow-md hover:shadow-xl ${system.highlight ? 'border-amber bg-amber/5' : 'border-gray-200'}`} data-id="element-415">
                <div className={`w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded flex items-center justify-center mb-4 md:mb-5 lg:mb-6 group-hover:scale-110 transition-transform bg-amber`} data-id="element-416">
                  <Icon className="h-5 w-5 md:h-6 md:w-6 lg:h-7 lg:w-7 text-navy" data-id="element-417" />
                </div>
                <div className="mb-2" data-id="element-418">
                  <div className="text-xs font-semibold text-amber uppercase tracking-wide mb-1" data-id="element-419">
                    {system.subtitle}
                  </div>
                  <h3 className="text-base md:text-lg lg:text-xl text-navy" data-id="element-420">
                    {system.title}
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed mb-4 md:mb-5 lg:mb-6 text-sm md:text-base" data-id="element-421">
                  {system.description}
                </p>
                <a href={system.link} className="inline-flex items-center text-amber font-semibold hover:text-amber-dark transition-colors text-sm md:text-base" data-id="element-422">
                  Learn More{' '}
                  <ArrowRightIcon className="ml-2 h-3 w-3 md:h-4 md:w-4" data-id="element-423" />
                </a>
              </div>;
        })}
        </div>

        <div className="text-center" data-id="element-424">
          <a href="/how-it-works" className="inline-block bg-navy hover:bg-navy-light text-white font-bold px-6 md:px-8 py-3 md:py-4 rounded transition-colors shadow-lg text-sm md:text-base" data-id="element-425">
            See the Complete System Breakdown →
          </a>
        </div>
      </div>
    </section>;
}